module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu0102-54bddf6fea0e17158897f55135489a2d.png";